import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/user-authorization/UserAuthorizationAction";
import { CustomSelect, UserTypeOptions, noUserAlert, redirectToPages, resultAlert } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { UserAuthorizationEditForm } from "./UserAuthorizationEditForm";

export function UserAuthorizationPage() {
  const [userType, setUserType] = useState();
  const [userId, setUserId] = useState();

  // Getting curret state of UserAuthorization from store (Redux)
  const dispatch = useDispatch();
  const { 
    actionLoading,
    isSuccess,
    type,
    users, 
    modules, 
    isSuperAdmin, 
    userGroupAuthorities,
    moduleAndAuthorities
  } = useSelector(
    (state) => ({
      actionLoading: state.userAuthorization.actionLoading,
      isSuccess: state.userAuthorization.isSuccess,
      type: state.userAuthorization.type,
      users: state.userAuthorization.users,
      modules: state.userAuthorization.entity.modules,
      isSuperAdmin: state.userAuthorization.isSuperAdmin,
      userGroupAuthorities: state.userAuthorization.userGroupAuthorities,
      moduleAndAuthorities: state.userAuthorization.moduleAndAuthorities
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getList());
    return () => dispatch(actions.cleanAll());
  }, [dispatch]);

  const saveAuthorities = (values) => {
    if (!userId) {
      noUserAlert();
      return;
    }
    dispatch(actions.saveAuthorities(userId, userType, values)).then((result) => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) dispatch(actions.getAuthorities(userType, userId));
  };
  
  const btnRef = useRef();  
  const saveAuthoritiesClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <>
      <Card>
        {actionLoading && <ModalProgressBar />}
        <CardHeader title="Kullanıcı Yetkilendirme" />
        <CardBody>
          <div className="form-group row">
            <div className="col-3 mt-3">
              Kullanıcı Türü <span>*</span>
            </div>
            <div className="col-5">
              <CustomSelect
                options={UserTypeOptions}
                onChange={option => dispatch(actions.getUsers(option.value)).then(() => {
                  dispatch(actions.cleanAuthorities());
                  setUserType(option.value);
                  setUserId(null);
                })}
              />
            </div>
          </div>
          
          <div className="form-group row">
            <div className="col-3 mt-3">
              Kullanıcı <span>*</span>
            </div>
            <div className="col-5">
              <CustomSelect
                options={users}
                value={userId}
                onChange={option => dispatch(actions.getAuthorities(userType, option.value)).then(() => setUserId(option.value))}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Kullanıcı Yetkileri" />
        <CardBody>
          <UserAuthorizationEditForm
            modules={modules}
            isSuperAdmin={isSuperAdmin}
            userGroupAuthorities={userGroupAuthorities}
            moduleAndAuthorities={moduleAndAuthorities}
            btnRef={btnRef}
            saveAuthorities={saveAuthorities}
          />
        </CardBody>
        <CardFooter>
          <div className="offset-sm-2">          
            <button
              type="submit"
              className="btn btn-primary"
              onClick={saveAuthoritiesClick}
            >
              Kaydet
            </button>
          </div>
        </CardFooter>
      </Card>
    </>    
  );
}